import Vue from 'vue'
import Vuex from 'vuex'
import {
    getToken
} from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: getToken()
    },
    mutations: {
        SET_TOKEN: (state, data) => {
            state.userInfo = data
        }
    },
    actions: {
        setToken({commit}, data) {
            commit('SET_TOKEN', data)
        }
    }
})
